import React, { useContext } from 'react';

import { CachedDCSContext, useCachedDCSInternal } from 'src/hooks/useCachedDCS';

const initialContext: CachedDCSContext = {
  isSellerAvailable: false,
  fetchBundles: bundleIds => Promise.resolve(),
  fetchProducts: productIds => Promise.resolve(),
  bundlesMap: {},
  productsMap: {},
};

const CachedDCS = React.createContext<CachedDCSContext>(initialContext);

export const useCachedDCS = () => useContext(CachedDCS);

export const CachedDCSProvider: React.FC = ({ children }) => {
  return (
    <CachedDCS.Provider value={useCachedDCSInternal()}>
      {children}
    </CachedDCS.Provider>
  );
};
